import React from 'react';

import {
  FormGroup,
  Typography,
  TextField,
} from '@material-ui/core';

import { parseMetricIntegerExpression } from "../utils/Parsers.js";

function isNumber(n) { return !isNaN(parseFloat(n)) && !isNaN(n - 0) }

//
// include this in your columnDefs options like this 
// { name: 'MyCol', options: { ...numericIntervalColumnFilterProps({ label: 'MyCol'}) } }
//
export function numericIntervalColumnFilterProps(props) {

  const { label="Range" } = props;
  
  let columnOptions = {
    
    // specialized the way a range chip looks when min/max or both are specified
    customFilterListOptions: {
      
      // this contols how the range chip content is rendered
      render: v => {
        if (v[0] && v[1]) {
          return `${label}: ${v[0]} - ${v[1]}`;
        } else if (v[0]) {
          return `${label}: >= ${v[0]}`;
        } else if (v[1]) {
          return `${label}: <= ${v[1]}`;
        }
        return [];
      },
      
      // this removes the filters when the range chip is deleted
      update: (filterList, filterPos, index) => {
        //console.log('customFilterListOnDelete: ', filterList, filterPos, index);

        if (filterPos === 0) {
          filterList[index].splice(filterPos, 1, '');
        } else if (filterPos === 1) {
          filterList[index].splice(filterPos, 1);
        } else if (filterPos === -1) {
          filterList[index] = [];
        }

        return filterList;
      },
    },
    filterType: 'custom',
    
    // customizes how the filter dialog gathers a range for this field
    filterOptions: {
      names: [],
      logic(value, filters) {
        let fromValue=parseMetricIntegerExpression(filters[0]);
        let toValue=parseMetricIntegerExpression(filters[1]);

        if (fromValue===0 && toValue===0) {
          return value!==0;
        } else if (isNumber(fromValue) && isNumber(toValue)) {
          return value < fromValue || value > toValue;
        } else if (isNumber(fromValue)) {
          return value < fromValue;
        } else if (isNumber(toValue)) {
          return value > toValue;
        }
        return false;
      },
      display: (filterList, onChange, index, column) => (
        <div style={{ padding: '0px' }}>
          <Typography variant="caption" color="textSecondary">{label}</Typography>
          <FormGroup row>
            <TextField
              label='From'
              value={filterList[index][0] || ''}
              onChange={event => {
                filterList[index][0] = event.target.value;
                onChange(filterList[index], index, column);
              }}
              style={{ width: '49%' }}
            />
            <TextField
              label='To'
              value={filterList[index][1] || ''}
              onChange={event => {
                filterList[index][1] = event.target.value;
                onChange(filterList[index], index, column);
              }}
              style={{ width: '49%', paddingLeft: '5px' }}
            />
          </FormGroup>
        </div>
      ),
    },
  };
  
  return columnOptions;
}